var _circle, _circle2, _path, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaternity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.52 42.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 14.845,
    cy: 25.308,
    r: 1.65
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 20.841,
    cy: 12.312,
    r: 6.848
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M24.944 19.168c-.05-.01-.11-.01-.16-.01h-7.89c-3.99 0-7.22 3.23-7.22 7.22v10.62h6.81"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_main",
    cx: 27.977,
    cy: 23.975,
    r: 4.868
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M31.675 27.138l.13.065-4.388 8.697c-.564 1.118-2.084 1.489-3.396.828l-3.943-1.988c-1.312-.661-1.918-2.105-1.353-3.223l4.387-8.696.13.065"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaternity);
export default __webpack_public_path__ + "static/media/paternity.f93868eb51fe8e4039ed34343112298a.svg";
export { ForwardRef as ReactComponent };